var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
export function MoneyInput(_a) {
    var name = _a.name, rest = __rest(_a, ["name"]);
    return (_jsx(Controller, { name: name, render: function (_a) {
            var field = _a.field;
            return (_jsx(FormControl, { sx: { width: '100%' }, children: _jsx(TextField, __assign({}, field, { autoComplete: name, name: name }, rest, { sx: {
                        '& fieldset': { border: 'none' },
                        marginBottom: 1,
                        border: 'none',
                    } })) }));
        } }));
}
